exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".paragraph[data-v-5be1e6e1]{height:32px;box-sizing:border-box;padding:5px}.paragraph-edit[data-v-5be1e6e1]{width:100%;height:100%;outline:none;text-align:left}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-5be1e6e1","scoped":true,"sourceMap":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/paragraph/paragraph.vue
// module id = 81
// module chunks = 0